import { getRequestForMyTeam, RequestResponse } from "@api";
import { FilterType, Table } from "@components";
import { Box } from "@material-ui/core";
import * as React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { Cell, Row } from "../../../components/table/types";
import { TABLE_HEADERS, TOOLTIPS } from "../constants";
import { useState } from "react";

const headers: Cell[] = [
  { data: TABLE_HEADERS.REF_NUMBER },
  { data: TABLE_HEADERS.USER_EMAIL },
  {
    data: TABLE_HEADERS.NAME,
    tooltip: TOOLTIPS.NAME,
  },
  { data: TABLE_HEADERS.ROLE },
  { data: TABLE_HEADERS.ENVIRONMENT },
  { data: TABLE_HEADERS.DATE_REQUESTED },
  { data: TABLE_HEADERS.STATUS },
];

export const MyTeamAccess: React.FC = () => {
  const history = useHistory();
  const [requests, setRequests] = React.useState<Row<RequestResponse>[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);

  useEffect(() => {
    getRequestForMyTeam().then((req: RequestResponse[]) => {
      setRequests(
        req.map((r: RequestResponse, index) => {
          return {
            cells: [
              {
                data: r.referenceNumber,
                index: index,
                color: "blue",
                cursor: "pointer",
                onClick: () => {
                  history.push(`/dashboard/requests/${r.encryptId}`);
                },
              },
              { data: r.userEmail, index: index },
              { data: r.subCategory, index: index },
              { data: r.role, index: index },
              { data: r.environment, index: index },
              { data: r.dateAdded, index: index },
              { data: r.status, index: index },
            ],
            data: r,
          };
        })
      );
      setIsloading(false);
    });
  }, [history]);

  return (
    <Box mt={2}>
      <Table
        data={requests}
        tableName={"My Team Access"}
        searchPlaceholder="Search by Reference No or Name, or user email"
        searchColumns={[
          TABLE_HEADERS.REF_NUMBER,
          TABLE_HEADERS.NAME,
          TABLE_HEADERS.USER_EMAIL,
        ]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="MY_TEAM_TOOLBAR"
        loading={isLoading}
        order="desc"
      />
    </Box>
  );
};
